import api from '../../../../../app/api';
import { InitiateBulkOrderPadRequest } from './types';

export async function submitBulkOrderService(payload: InitiateBulkOrderPadRequest): Promise<string> {
  const response = await api.post('/bff/InitiateBulkOrderPad', payload);
  return Promise.resolve<string>(response.data);
}
